import $ from './container.scss';

export function Container({ children }: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
    return <div className={$.container}>{children}</div>;
}
